<template>
  <div class="cms-rendered-content prose-cms min-w-0 max-w-full">
    <div class="cms-rendered-content__body min-w-0 max-w-full" v-html="html" />
  </div>
</template>

<script setup lang="ts">
import { useStyleTag } from '@vueuse/core'
import { parseCmsContent, scopeCmsCss } from '~/utils/cms-content'

const props = defineProps<{
  content?: string | null
}>()

const parsed = computed(() => parseCmsContent(props.content))
const html = computed(() => parsed.value.html)
const css = computed(() => scopeCmsCss(parsed.value.css || ''))

useStyleTag(css)
</script>

<style scoped>
/*
  Always keep CMS content inside the page width on mobile.
  GrapesJS often saves fixed px widths / large images that would otherwise overflow.
*/
.cms-rendered-content {
  overflow-x: auto;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.cms-rendered-content__body {
  max-width: 100%;
}

.cms-rendered-content :deep(*) {
  box-sizing: border-box;
  max-width: 100%;
}

.cms-rendered-content :deep(img),
.cms-rendered-content :deep(video),
.cms-rendered-content :deep(iframe),
.cms-rendered-content :deep(embed),
.cms-rendered-content :deep(object),
.cms-rendered-content :deep(svg) {
  max-width: 100% !important;
  height: auto !important;
}

.cms-rendered-content :deep(table) {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  border-collapse: collapse;
}

.cms-rendered-content :deep(pre),
.cms-rendered-content :deep(code) {
  max-width: 100%;
  overflow-x: auto;
  white-space: pre-wrap;
}

.cms-rendered-content :deep(th),
.cms-rendered-content :deep(td) {
  border: 1px solid var(--ui-border-muted);
  padding: 0.5rem 0.75rem;
}
</style>
